
@if (api.isLogged) {
  <div class="navbar-container">

  <!-- Top navbar -->
  <mat-toolbar class="navbar" color="primary">

    <div style="width: 100%;height: 100%;align-items: center;display: flex;" class="nav-menu">
      <div class="navbar-brand">
        <a href="/">
          <img src="assets/img/prima-logo-gray.png" class="prima-logo">
        </a>
      </div>
      @if (api.isAdmin) {
        <div class="menu">
          <a mat-flat-button color="secondary" style="order: 2;" class="navbar-adm" [routerLink]="['admin/users']"><mat-icon slot="start">groups</mat-icon><span class="hideOnMobile">Přehled uživatelů</span></a>
          <a mat-flat-button color="secondary" style="order: 2;" class="navbar-adm" [routerLink]="['admin/anonymization']"><mat-icon slot="start">disabled_visible</mat-icon><span class="hideOnMobile">Žádosti o anonymizaci</span></a>
        </div>
      }
      @if (api.isLogged) {
        <div class="settingsBtn list dropdown-custom-menu">
          <button href="#" mat-icon-button color="secondary"><mat-icon slot="start">settings</mat-icon></button>
          <div class="dropdown-menu-content">
            <a class="actionBtn logoutBtn dropdown-menu-content-item" mat-flat-button (click)="logout()"><mat-icon slot="start">logout</mat-icon> Odhlásit se</a><br>
            @if (!api.isAdmin) {
              <a class="actionBtn forgetBtn dropdown-menu-content-item" mat-flat-button (click)="anonymize()"><mat-icon slot="start">person_remove</mat-icon> Zapomenout má data</a>
            }
            @else {
              <a class="actionBtn forgetBtn dropdown-menu-content-item" mat-flat-button (click)="getToken()"><mat-icon slot="start">token</mat-icon> Job Token</a>
            }
          </div>
        </div>
      }
      <div class="span-user">
        <mat-icon class="mat-icon" slot="start">account_circle</mat-icon>
        {{api.username}}
      </div>
    </div>
  </mat-toolbar>
</div>
}
<div class="content">
  <router-outlet></router-outlet>
</div>
@if (api.isLogged) {
  <app-help></app-help>
}
